import { render, staticRenderFns } from "./ResultsByUniverses.vue?vue&type=template&id=5ee4db97&"
import script from "./ResultsByUniverses.vue?vue&type=script&lang=js&"
export * from "./ResultsByUniverses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports